import React, { useState, useEffect } from 'react';
import './PLPFiltersModal.scss';

import PLPFiltersItem from '../PLPFiltersItem/PLPFiltersItem';
import OdCrossIcon from '../../../../../static/assets/svg/od-cross-icon.svg';

import { connect } from 'react-redux';
import localStorageHelper from '../../../../utils/localStorageHelper';
import { v4 } from 'uuid';

const PLPFiltersModal = props => {
  const { dataLocale, handleClose, filterData, categoryType, modifySelectedFilterList } = props;

  const [userFrameSize, setUserFrameSize] = useState('');

  const { ALL_FILTERS } = dataLocale;

  let FilterResult;

  if (filterData?.result) {
    FilterResult = filterData.result.filters;

    const frameSizeFilterIndex = FilterResult.findIndex(filter => filter.id === 'frame_size_id');

    if (userFrameSize && frameSizeFilterIndex > 2) {
      FilterResult.splice(2, 0, FilterResult[frameSizeFilterIndex]);
      FilterResult.splice(frameSizeFilterIndex + 1, 1);
    }
  }

  const prefSize = localStorageHelper.getItem('prefSize');

  useEffect(() => {
    if (prefSize && categoryType) {
      setUserFrameSize(prefSize[categoryType.toLowerCase()]);
    }
  }, []);

  return (
    <div className="plp-filters-modal">
      <div className="plp-filters-modal__content">
        <div className="plp-filters-modal__header">
          <div className="plp-filters-modal__title od-font-bold">{ALL_FILTERS.toLowerCase()}</div>
          <img
            alt="Close"
            className="plp-filters-modal__close-icon"
            src={OdCrossIcon}
            onClick={handleClose}
          />
        </div>
        <div>
          {FilterResult?.map((filter, index) => {
            return (
              <div key={index}>
                {filter.data.length > 0 && (
                  <PLPFiltersItem
                    key={v4()}
                    filter={filter}
                    modifySelectedFilterList={modifySelectedFilterList}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="plp-filters-modal__overlay" onClick={handleClose} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
    filterData: state.category.filterData,
    categoryType: state.category.categoryType,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PLPFiltersModal);
